export var MovePlayersStatus;
(function (MovePlayersStatus) {
    MovePlayersStatus["SUCCESS"] = "success";
    MovePlayersStatus["PARTIAL_SUCCESS"] = "partial_success";
    MovePlayersStatus["ERROR"] = "error";
})(MovePlayersStatus || (MovePlayersStatus = {}));
export var ValidationReason;
(function (ValidationReason) {
    ValidationReason["AGE_RESTRICTION"] = "AGE_RESTRICTION";
    ValidationReason["ALREADY_ON_TEAM"] = "ALREADY_ON_TEAM";
    ValidationReason["GENDER_RESTRICTION"] = "GENDER_RESTRICTION";
    ValidationReason["MISSING_TEAM"] = "MISSING_TEAM";
})(ValidationReason || (ValidationReason = {}));
export var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["ALL_VALID"] = "all_valid";
    ValidationStatus["ALL_INVALID"] = "all_invalid";
    ValidationStatus["PARTIAL"] = "partial";
    ValidationStatus["CAPACITY_ERROR"] = "capacity_error";
})(ValidationStatus || (ValidationStatus = {}));
